import './App.css';

const avatarUrl = 'https://avatars.githubusercontent.com/u/34222369?v=4';

const projects = [
  {
    name: 'RL365',
    label: 'Reinforcement learning',
    description:
      'A public self-learning journey through reinforcement learning, documented through short posts and experiments.',
    href: 'https://x.com/ianmurray33',
    action: 'Follow the thread',
    accent: 'rl',
  },
  {
    name: 'HomeLab',
    label: 'Infrastructure at home',
    description:
      'Five Dell enterprise boxes running Ubuntu at home, connected over Tailscale and used as remote servers for Claude Code and agent workflows.',
    href: null,
    action: 'In progress',
    accent: 'lab',
  },
  {
    name: 'TimeToLift',
    label: 'Team accountability',
    description:
      'A GitHub project inspired by college lacrosse that helps teams make sure everyone is awake and accountable for lifting.',
    href: 'https://github.com/ianm101/TimeToLift',
    action: 'View project',
    accent: 'lift',
  },
  {
    name: 'Planim',
    label: 'Visual coding plans',
    description:
      "A planned Claude Code and Codex plugin that uses Manim to turn assistant plans into digestible visual explanations.",
    href: null,
    action: 'Coming soon',
    accent: 'planim',
  },
];

function App() {
  return (
    <main className="site-shell">
      <header className="hero" id="home">
        <nav className="top-nav" aria-label="Primary navigation">
          <a href="#home" className="brand">
            Ian Murray
          </a>
          <div className="nav-links">
            <a href="#work">Work</a>
            <a href="#education">Education</a>
            <a href="#projects">Projects</a>
          </div>
        </nav>

        <div className="hero-content">
          <div className="hero-copy">
            <p className="eyebrow">Investor and builder</p>
            <h1>Ian Murray</h1>
            <p className="bio">
              I am an infrastructure investor at Brighton Park Capital with a
              computer science background from Princeton. I spend my free time
              building tools, learning reinforcement learning, and running a
              small home lab for AI agent workflows.
            </p>
            <div className="hero-actions" aria-label="Profile links">
              <a href="#projects">View projects</a>
              <a href="https://github.com/ianm101" target="_blank" rel="noreferrer">
                GitHub
              </a>
              <a href="https://x.com/ianmurray33" target="_blank" rel="noreferrer">
                X
              </a>
            </div>
          </div>

          <figure className="profile-figure">
            <img src={avatarUrl} alt="Ian Murray" />
            <figcaption>Infrastructure, software, and applied AI.</figcaption>
          </figure>
        </div>
      </header>

      <section className="section-grid" aria-label="Current work and education">
        <article className="info-panel" id="work">
          <p className="section-kicker">What I&apos;m Up To</p>
          <h2>Infrastructure investor at Brighton Park Capital</h2>
          <p>
            I focus on infrastructure software and technology businesses, with
            an eye toward systems that compound through better tooling,
            distribution, and execution.
          </p>
        </article>

        <article className="info-panel" id="education">
          <p className="section-kicker">Education</p>
          <h2>Princeton University &apos;24</h2>
          <p>BSE in Computer Science.</p>
        </article>
      </section>

      <section className="projects-section" id="projects">
        <div className="section-heading">
          <p className="section-kicker">Projects</p>
          <h2>Current and upcoming work</h2>
        </div>

        <div className="project-grid">
          {projects.map((project) => (
            <article className="project-card" key={project.name}>
              <div className={`project-thumb ${project.accent}`} aria-hidden="true">
                <span>{project.name}</span>
              </div>
              <div className="project-body">
                <p className="project-label">{project.label}</p>
                <h3>{project.name}</h3>
                <p>{project.description}</p>
                {project.href ? (
                  <a href={project.href} target="_blank" rel="noreferrer">
                    {project.action}
                  </a>
                ) : (
                  <span className="muted-action">{project.action}</span>
                )}
              </div>
            </article>
          ))}
        </div>
      </section>

      <footer className="site-footer">
        <span>ianmurray.io</span>
        <span>Built from Princeton CS roots and infrastructure curiosity.</span>
      </footer>
    </main>
  );
}

export default App;
